module.exports = __webpack_public_path__ + "static/media/icon-time-black.6d0ff801.svg";